<template>
  <div class="row">
    <div class="col col-md-7 border rounded-3">
      <div class="row border-bottom">
        <div class="col px-0 mx-0">
          <div class="row">
            <div class="col">
              <img src="@/assets/GL_bg.jpg" style="width: 100%" />
            </div>
          </div>
          <div class="row mx-1">
            <div class="col-3 position-relative">
              <span
                class="position-absolute top-0 start-50 translate-middle ml-6"
                ><img
                  src="@/assets/avatar.jpg"
                  style="width: 120px"
                  class="rounded-circle border border-3 border-light"
              /></span>
            </div>
            <div class="col px-1">
              <button
                class="btn btn-outline-dark rounded-circle float-end mt-1"
                type="button"
              >
                <i class="fas fa-ellipsis-h"></i>
              </button>
            </div>
          </div>
          <div class="row mx-1 mt-3">
            <div class="col">
              <h4>Taha Malaldır</h4>
            </div>
          </div>
          <div class="row mx-1">
            <div class="col">
              <p class="mb-0">DÜ - Computer Engineering</p>
            </div>
          </div>
          <div class="row mx-1 mt-0">
            <div class="col-auto">
              <p>103 <span class="text-muted">Takipçi</span></p>
            </div>
            <div class="col-auto">
              <p>103 <span class="text-muted">Takipçi</span></p>
            </div>
          </div>
        </div>
      </div>
      <paylasim-card v-for="i in 5" :key="i" />
    </div>
    <sidefix />
  </div>
</template>
<script>
import Sidefix from "../components/Shared/Sidefix.vue";
import PaylasimCard from "../components/Pages/Anasayfa/PaylasimCard.vue";
export default {
  components: { Sidefix, PaylasimCard },
};
</script>

<style></style>
